import {
  ColumnTitle,
  defaultHeaderComponents,
  HeaderRendererProps,
} from "@sinecycle/growcomponents";
import { Row } from "antd";

function CFHeader<T>(props: HeaderRendererProps<T>) {
  return (
    <Row wrap={false}>
      {defaultHeaderComponents.defaultHeader({
        ...props,
        headerStyles: { cursor: "auto" },
      })}
      &nbsp;
      <ColumnTitle hasSymbol />
    </Row>
  );
}

export { CFHeader };
